import { collectionsService } from '@services/firebase/firestore/functionFactory';
import { Member } from '@vincerosoft/assessfluence-types';
import { where } from 'firebase/firestore';

function membersFactory() {
  const getMembersByUserId = async (userId: string) => {
    return collectionsService.members.getDocs<Member>([where('user_id', '==', userId)]);
  };

  const getMembersByIds = async (memberIds: string[], onProgress?: (members: Member[]) => void) => {
    const members = await collectionsService.members.getDocsInBatches(
      ['id', 'in', memberIds],
      undefined,
      onProgress
    );
    return members.flat();
  };

  const getMembersByOrgNodeId = async (orgNodeId: string) => {
    return collectionsService.members.getDocs<Member>([where('org_node_id', '==', orgNodeId)]);
  };

  return {
    getMembersByUserId,
    getMembersByIds,
    getMembersByOrgNodeId
  };
}

export const membersService = membersFactory();
